import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import {
  productDetailsView,
  pushRemarketingEvent,
} from '../../shared/lib/gaEnhancedEcommerce';

import { loadProductBySeoName } from '../../../redux/modules/singleProduct';
import {
  getCategoryType,
  getCategoryName,
  getSubcategoryName,
} from '../../../redux/modules/categories';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import DettaglioProdotto from './DettaglioProdotto/DettaglioProdotto';

import { FaSpinner } from 'react-icons/fa';
import './Prodotto.scss';
import IubendaCookieSolution from '../../../utils/iubenda';
import {
  ga4ViewItem,
  ga4ViewItemList,
} from '../../shared/lib/ga4EnhancedEcommerce';
import {
  fkmxViewItem,
  fkmxViewItemList,
} from '../../shared/lib/farmakomMetrics';

import NonDisponibile from './NonDisponibile/NonDisponibile';
import { getSHA256Hash } from '../../../utils/sha256';

class Prodotto extends Component {
  state = { ga4Viewed: false, fkmxViewed: false };

  componentDidMount() {
    // IUBENDA
    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );

    ///////////////////////////////////////
    // GOOGLE ANALYTICS: PRODUCT DETAILS
    setTimeout(() => {
      if (this.props.advancedGa) {
        productDetailsView(
          {
            id: this.props.product.code || '',
            name: this.props.product.name,
            category: this.props.categoryName,
            brand: this.props.product.brand,
          },
          this.props.product
        );
      }
      // REMARKETING DINAMICO
      if (this.props.hasDynamicRemarketing) {
        pushRemarketingEvent('product', this.props.product);
      }
      // GA4 TRACK PRODUCT VIEW
      if (
        this.props.hasGoogleAnalytics4Advanced &&
        !!Object.keys(this.props.product || {}).length
      ) {
        this.ga4ViewItem(this.props.product);
      }
      // FKMX TRACK PRODUCT VIEW
      if (this.props.hasFarmakomMetrics) {
        this.fkmxViewItem(this.props.product);
      }
    }, 1000);

    /////////////////////////////
    // CRITEO PRODUT DETAILS TAG
    if (this.props.hasCriteo) {
      if (this.props.product.id) {
        const oldTag = document.getElementById('criteo_product_tag');
        if (!oldTag) {
          iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
        }
      }
    }
  }

  componentDidUpdate(oldProps, oldState, prevProps) {
    if (
      this.props.product.id !== oldProps.product.id &&
      !!this.props.product.id
    ) {
      this.setState({ ga4Viewed: false, fkmxViewed: false });
      /////////////////////////////
      // CRITEO PRODUT DETAILS TAG
      if (this.props.hasCriteo) {
        const iubenda = new IubendaCookieSolution(
          this.props.hasIubendaCookieSolution
        );
        iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
      }
      // REMARKETING DINAMICO
      if (this.props.hasDynamicRemarketing) {
        pushRemarketingEvent('product', this.props.product);
      }
    }
    if (oldState.ga4Viewed !== this.state.ga4Viewed && !this.state.ga4Viewed) {
      // GA4 TRACK PRODUCT VIEW
      if (
        this.props.hasGoogleAnalytics4Advanced &&
        !!Object.keys(this.props.product || {}).length
      ) {
        this.ga4ViewItem(this.props.product);
      }
    }
    if (
      oldState.fkmxViewed !== this.state.fkmxViewed &&
      !this.state.fkmxViewed
    ) {
      // FKMX TRACK PRODUCT VIEW
      if (
        this.props.hasFarmakomMetrics &&
        !!Object.keys(this.props.product || {}).length
      ) {
        this.fkmxViewItem(this.props.product);
      }
    }
  }

  ga4ViewItem = () => {
    if (!this.state.ga4Viewed) {
      const { product } = this.props;
      ga4ViewItem(product);

      if (product.boughtTogether) {
        ga4ViewItemList(product.boughtTogether, {
          id: `bought_together_${product.seoName}`,
          name: `Bought Together > ${product.seoName}`,
        });
      }

      if (product.similar) {
        ga4ViewItemList(product.similar, {
          id: `similar_products_${product.seoName}`,
          name: `Similar Products > ${product.seoName}`,
        });
      }

      this.setState({ ga4Viewed: true });
    }
  };

  fkmxViewItem = () => {
    if (!this.state.fkmxViewed) {
      const { product } = this.props;

      fkmxViewItem(product);

      if (product.boughtTogether) {
        fkmxViewItemList(product.boughtTogether, {
          id: `bought_together_${product.seoName}`,
          name: `Bought Together > ${product.seoName}`,
        });
      }

      if (product.similar) {
        fkmxViewItemList(product.similar, {
          id: `similar_products_${product.seoName}`,
          name: `Similar Products > ${product.seoName}`,
        });
      }

      this.setState({ fkmxViewed: true });
    }
  };

  renderCriteoTag = async () => {
    // <!-- Criteo Product Tag -->
    const email = (this.props.user && this.props.user.email) || '';
    if (!!email) {
      const zipcode =
        (this.props.user &&
          this.props.user.shipping &&
          this.props.user.shipping.zipcode) ||
        '';

      const criteo_product_tag = document.createElement('script');
      criteo_product_tag.id = 'criteo_product_tag';
      criteo_product_tag.type = 'text/javascript';
      criteo_product_tag.innerHTML = `
          window.criteo_q = window.criteo_q || [];
          var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
          window.criteo_q.push(
            { event: "setAccount", account: ${this.props.criteoAccountId} },
            { event: "setEmail", email: "${await getSHA256Hash(
              email
            )}", hash_method: "sha256" },
            { event: "setZipcode", zipcode: "${zipcode}" },
            { event: "setSiteType", type: deviceType },
            { event: "viewItem", item: "${this.props.product.id}" }
          );
      `;
      setTimeout(() => {
        document.body.appendChild(criteo_product_tag);
      }, 200);
    }
    // <!-- END Criteo Product Tag -->
  };

  render() {
    let {
      product,
      loading,
      error,
      categoryName,
      subcategoryName,
      siteName,
      siteUrl,
      linkDrugsAuthorizedSite,
      linkDrugsAuthorizedSiteVet,
    } = this.props;

    const goTo = path => {
      this.props.router.push(path);
    };

    // Pagina prodotto non disponibile
    if (!loading && !!error && error.includes('404')) {
      return (
        <NonDisponibile
          category={this.props.params.category}
          subcategory={this.props.params.subcategory}
          product={this.props.params.product}
          goTo={goTo}
        />
      );
    }

    return (
      <div className="prodotto">
        <Helmet
          title={product.seoTitle ? product.seoTitle : product.name}
          meta={[
            {
              name: 'description',
              content: `${
                product.seoDescription
                  ? product.seoDescription
                  : `${siteName} - ${product.name} ${categoryName} ${subcategoryName}`
              }`,
            },
            {
              name: 'keywords',
              content: `${
                product.seoKeywords
                  ? product.seoKeywords
                  : `${product.name}, ${categoryName}, ${subcategoryName}, ${siteName}, ecommerce farmacia`
              }`,
            },
            {
              name: 'robots',
              content: 'index, follow',
            },
            {
              property: 'og:title',
              content: `${
                product.seoTitle
                  ? product.seoTitle
                  : `${siteName} - ${product.name} ${categoryName} ${subcategoryName}`
              }`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${
                product.seoDescription
                  ? product.seoDescription
                  : `${siteName} - ${product.name} ${categoryName} ${subcategoryName}`
              }`,
            },
            { property: 'og:image', content: product.image },
            {
              property: 'og:url',
              content: `${siteUrl}/${product.type}/${
                product.categorySeoName
              }/${product.subcategorySeoName || '_'}/${product.seoName}`,
            },
          ]}
          link={[
            {
              rel: 'canonical',
              href: `${siteUrl}/${product.type}/${
                product.categorySeoName
              }/${product.subcategorySeoName || '_'}/${product.seoName}`,
            },
          ]}
        />

        {loading && (
          <div className="container">
            <div className="loading">
              <FaSpinner className="pulse" />
            </div>
          </div>
        )}

        {!loading && product && (
          <DettaglioProdotto
            product={product}
            category={this.props.params.category}
            subcategory={this.props.params.subcategory}
            categoryName={categoryName}
            subcategoryName={subcategoryName}
            linkDrugsAuthorizedSite={linkDrugsAuthorizedSite}
            linkDrugsAuthorizedSiteVet={linkDrugsAuthorizedSiteVet}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user.data,
    product: state.singleProduct.data,
    error: state.singleProduct.error,
    loading: state.singleProduct.loading,
    categoryName: getCategoryName(state, ownProps.params.category),
    categoryType: getCategoryType(state, ownProps.params.category),
    subcategoryName: getSubcategoryName(state, ownProps.params.subcategory),
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    advancedGa: state.store.data.features.advancedGa,
    linkDrugsAuthorizedSite:
      state.store.data.datiFarmacia.linkDrugsAuthorizedSite,
    linkDrugsAuthorizedSiteVet:
      state.store.data.datiFarmacia.linkDrugsAuthorizedSiteVet,
    hasCriteo: state.store.data.features.hasCriteo,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    uiVariantThumbnail: state.store.data.uiVariants.thumbnail,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    hasTradedoubler: state.store.data.features.hasTradedoubler,
    tradedoubler: state.store.data.integrazioni.tradedoubler,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    products: state.products.data,
  };
}

export default withRouter(
  connect(mapStateToProps)(
    connectDataFetchers(Prodotto, [loadProductBySeoName])
  )
);
